<template>
<div class="contents">
    <div class="wrap">
        <section>
          <h2 class="page_title --view">약재 신규 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <!--
                <tr>
                  <th><span>코드</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.grpCode">
                  </td>
                </tr>
                -->
                <tr>
                  <th><span>약재명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.medicineNm">
                  </td>
                </tr>        
                <tr>
                  <th><span>설명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.medPrfm">
                  </td>
                </tr>
                <tr>
                  <th><span>이명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.medAlias">
                  </td>
                </tr>
                <tr>
                  <th><span>성미</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.property_taste">
                  </td>
                </tr>
                <tr>
                  <th><span>귀경</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.meridian_tropism">
                  </td>
                </tr>
                <tr>
                  <th><span>사상</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.sasang_type">
                  </td>
                </tr>
                <tr>
                  <th><span>학명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.scientific_name">
                  </td>
                </tr>
                <tr>
                  <th><span>효과효능</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.efficacy_effect">
                  </td>
                </tr>
                <tr>
                  <th><span>주의사항</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;"  v-model="regData.precautions"></textarea>
                  </td>
                </tr>
                <tr>
                  <th><span>참고사항</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;"  v-model="regData.additional_info"></textarea>
                  </td>
                </tr>
                <tr>
                  <th><span>탕전방법</span></th>
                  <td>
                    <div class="form_select">
                      <b-form-select v-model="regData.tangenWay">
                          <b-form-select-option value="">업음</b-form-select-option>
                          <b-form-select-option value="B">선전</b-form-select-option>
                          <b-form-select-option value="A">후하</b-form-select-option>
                      </b-form-select>
                      <input type="text" v-if="regData.tangenWay != ''" class="form_control w100" placeholder="입력해주세요." v-model="regData.tangenWayTime"><span v-if="regData.tangenWay != ''">분</span>
                      </div>
                  </td>
                </tr>         
                <tr>
                  <th><span>검색유무</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="radio1" name="radio" value="Y" v-model="regData.useYn">
                        <label for="radio1">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="radio2" name="radio" value="N" v-model="regData.useYn">
                        <label for="radio2">N</label>
                      </div>
                    </div>                   
                  </td>
                </tr>        
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- button class="btn btn_md btn_gray">취소</button -->
                <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
import axios from 'axios'

  export default {
    name: 'MedicineMngtReg',
    data() {
        return {
            regData : {
                medicineCd : "",
                medicineNm : "",
                medPrfm : "",
                medAlias : "",
                useYn : "Y",
                tangenWay : '',
                tangenWayTime : '',
                property_taste : '',
                meridian_tropism : '',
                sasang_type : '',
                scientific_name : '',
                efficacy_effect : '',
                precautions : '',
                additional_info : '',
                status : ''
            }
        }
    },
    mounted(){
          this.regData.status = this.$store.getters['medicine/getStatus'];
          
          if(this.regData.status == 'M'){
              this.regData.medicineCd = this.$store.getters['medicine/getMedicineCd'];  

              console.log("@@@@ this.regData.medicineCd :"+this.regData.medicineCd);

              this.fn_search(); 
          }
      },
    methods : {
        fn_reg(){

            //console.log("@@@@ regData : %o",this.regData);

                axios.post("/api/medicine/regMedicine", 
                    this.regData
                ).then((res) => {
                console.log("@@@@ res : %o",res);

                alert("저장되었습니다");
                this.fn_move_page();
            })
            .catch((err) => console.log(err));

        
        },
        fn_search(){

          let param = new Object();
          param.medicineCd = this.regData.medicineCd;

          console.log("@@@@ param : %o",param);

          axios
              .post("/api/medicine/medicineDetail", param)
              .then((res) => {
                  console.log("@@@@ dtl res : %o",res);
                  
                  //this.regData.medicineCd = res.data.med_hrb_cd;
                  this.regData.medicineNm = res.data.med_hrb_nm;
                  this.regData.medPrfm = res.data.med_prfm;
                  this.regData.medAlias = res.data.med_alias
                  this.regData.useYn = res.data.use_yn
                  this.regData.tangenWay = res.data.tangen_way;
                  this.regData.tangenWayTime = res.data.tangen_way_time;
                  this.regData.property_taste = res.data.property_taste;
                  this.regData.meridian_tropism = res.data.meridian_tropism;
                  this.regData.sasang_type = res.data.sasang_type;
                  this.regData.scientific_name = res.data.scientific_name;
                  this.regData.efficacy_effect = res.data.efficacy_effect;
                  this.regData.precautions = res.data.precautions;
                  this.regData.additional_info = res.data.additional_info;

              })
              .catch((err) => console.log(err));
                
        },
        fn_move_page(){
            //약재관리 화면으로 이동
            this.$router.push("/admin/medicine/medicineMngt");
        }
    }
  }
</script>